import { Link } from 'react-router-dom';
import type { EventItem } from '@/mocks/events';
import { formatDate, formatViews } from '@/utils/news';

interface HotRankingProps {
  items: EventItem[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <ul className="divide-y divide-background-200">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="flex items-start gap-3 p-4 hover:bg-background-100 transition-colors"
            >
              <span
                className={`shrink-0 w-7 h-7 rounded-md flex items-center justify-center font-heading font-bold text-sm ${
                  i === 0
                    ? 'bg-primary-500 text-background-50'
                    : i === 1
                      ? 'bg-primary-200 text-primary-900'
                      : 'bg-secondary-100 text-foreground-600'
                }`}
              >
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-price-tag-3-line"></i>
                    {item.categoryName}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(item.views)}
                  </span>
                  <span className="hidden sm:inline-flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {formatDate(item.date)}
                  </span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}